<template>
    <v-dialog v-model="dialog" max-width="500">
        <v-card class="v-card--dialog v-card--dialog--sm">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">현금영수증 신청</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="d-inline-flex flex-wrap align-center font-size-14 line-height-1">
                <v-col cols="12">
                    <v-row>
                        <v-col>
                            <v-checkbox v-model="order.cashbill.status" :value="true" hide-details label="현금영수증 신청" class="ma-0"></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <v-radio-group v-model="order.cashbill.tradeUsage" :disabled="!order.cashbill.status">
                                    <v-radio label="개인 소득 공제" value="소득공제용"></v-radio>
                                    <v-radio label="사업자 지출 증빙" value="지출증빙용"></v-radio>
                            </v-radio-group>
                            <v-select v-if="order.cashbill.tradeUsage === '소득공제용'" v-model="cashbillType" :disabled="!order.cashbill.status" :items="items" outlined persistent-placeholder hide-details />
                            <v-text-field v-model="order.cashbill.identityNum" :placeholder="displayCashbillPlaceholder" :disabled="!order.cashbill.status" outlined persistent-placeholder hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </div>
            <div class="v-card--dialog__foot">
                <v-row class="row--x-small">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="cashbill">신청</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            order: null,

            dialog: false,

            cashbillType: "휴대폰번호",
            tradeUsage: "소득공제용",
            items: [
                { text: "휴대폰 번호", value: "휴대폰번호"},
                { text: "현금영수증 카드번호", value: "카드번호"},
            ],
        }
    },
    methods: {
        open(){
            this.dialog = true;
        },
        close(){
            this.dialog = false;
        },
        validate() {
            try {
                if(!this.order.cashbill.status) throw new Error("현금영수증 신청을 선택해주세요")
                if(!this.order.cashbill.tradeUsage) throw new Error("개인 소득 공제 또는 사업자 지출 증빙을 선택해주세요")
                if(!this.order.cashbill.identityNum) throw new Error("핸드폰번호, 카드번호 또는 사업자 등록번호를 입력해주세요")
                if(this.order.cashbill.status) {
                    return confirm(`${this.order.cashbill.identityNum}으로 현금영수증 신청을 진행하시겠습니까?`)
                }
                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async cashbill() {
            if(this.validate()) {
                let { success } = await api.v1.me.shop.cashbill.post({
                    order: this.order
                })
                if(success) {
                    alert("현금영수증이 신청되었습니다.")
                    this.close()
                }
            }
        }
    },
    computed: {
        displayCashbillPlaceholder() {
            if(this.order.cashbill.tradeUsage === "지출증빙용") {
                return "사업자등록번호를 -없이 입력해 주세요."
            } else if(this.order.cashbill.tradeUsage === "소득공제용" && this.cashbillType === "휴대폰번호") {
                return "휴대폰 번호를 입력주세요."
            } else {
                return "카드번호를 -없이 입력해 주세요."
            }
        }
    },
    watch: {
        dialog(){
            if(!this.dialog) this.$emit("close");
        },
    }
}
</script>